export const CertificationStatus = {
  INACTIVE: 'INACTIVE',
  NEAR_EXPIRATION: 'NEAR_EXPIRATION',
  ACTIVE: 'ACTIVE'
}
